if (!customElements.get("product-tabs")) {
  class ProductTabs extends HTMLElement {
    constructor() {
      super();
      this.id = this.getAttribute("id");

      if (Shopify.designMode) {
        window.addEventListener("shopify:section:load", this.init.bind(this));
      }
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.querySelectorAll(".product__tab--trigger").forEach(tabTrigger => {
        tabTrigger.setAttribute("aria-expanded", "false");
        const hedef = tabTrigger.dataset.tab;
        if (hedef) tabTrigger.setAttribute("aria-controls", hedef);
        tabTrigger.addEventListener("click", evt => {
          this.openTab(evt, tabTrigger.dataset.tab);
        });
      });

      // Mobilde hicbir sekme acik baslamaz. Acik "Details" paneli 845px yer
      // kapliyor ve "Add to cart" butonunu ekranin ~2 boy asagisina itiyordu.
      // Genis ekranda eski davranis korunuyor.
      if (window.matchMedia("(min-width: 768px)").matches) {
        this.openDefaultTab();
      }
    }

    openDefaultTab() {
      const event = new MouseEvent("click", { view: window, bubbles: true, cancelable: true });
      this.querySelector(".product__tab[data-default-open]")?.dispatchEvent(event);
    }

    openTab(evt, tabName) {
      const trigger = evt.currentTarget;
      const zatenAcik = trigger && trigger.classList.contains("active");

      this.querySelectorAll(".product__tab-content").forEach(content => {
        content.style.display = "none";
      });
      this.querySelectorAll(".product__tab").forEach(link => {
        link.classList.remove("active");
        link.setAttribute("aria-expanded", "false");
      });

      // Ayni sekmeye tekrar tiklanirsa kapanir - acilir/kapanir davranis
      if (zatenAcik) return;

      let secici;
      try { secici = "#" + CSS.escape(tabName); } catch (e) { secici = "#" + tabName; }
      const currentTabContent = this.querySelector(secici);

      if (currentTabContent) {
        currentTabContent.style.display = "block";
        if (trigger) {
          trigger.classList.add("active");
          trigger.setAttribute("aria-expanded", "true");
        }
      }
    }
  }
  customElements.define("product-tabs", ProductTabs);
}
